import ExcelJS from "exceljs"
import fileDownload from "js-file-download"
import { toast } from "react-toastify"

export const jsonToExcel = async (
  name,
  data,
  worksheetName = "ManejeSheet",
  data2 = [],
  worksheetName2,
) => {
  if (data.length > 0) {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(worksheetName)

    const columns = Object.keys(data[0]).map((header) => ({
      header,
      key: header,
      width: 80,
    }))

    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 8,
      bold: true,
      color: { argb: "#000000" },
    }

    data.map((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }

    if (worksheetName2) {
      const worksheet2 = workbook.addWorksheet(worksheetName2)

      const columns2 = Object.keys(data2[0]).map((header) => ({
        header,
        key: header,
        width: 80,
      }))

      worksheet2.columns = columns2

      data2.map((row) => {
        worksheet2.addRow(row)
        return row
      })

      worksheet2.getRow(1).font = {
        name: "Lato",
        size: 8,
        bold: true,
        color: { argb: "#000000" },
      }

      worksheet2.autoFilter = {
        from: "A1",
        to: "Z1",
      }
    }

    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `${name}_${Date.now()}.xlsx`)
  } else {
    toast.error("Não há dados para gerar este relátorio")
  }
}
